<div class="container-account-settings d-flex justify-content-center align-items-center column">
  <div class="mx-auto form-account-settings">
    <mat-card class="center-block container-account-settings-form">
      <app-change-password [allWidth]="true"></app-change-password>
    </mat-card>
  </div>
</div>